import type {BaseComponentPart, StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {EntityCardEntityType} from '@Components/ai-chat-window/components/entity-card/entity-card.types';
import type {EntityThumbnail} from '@Components/ai-chat-window/components/entity-thumbnail-tile/entity-thumbnail-tile.types';

export const MIN_STREAMED_THUMBNAILS_TO_RENDER = 1;

/** The header copy and icons a tile of one entity type shows, as translation keys and icon classes. */
export interface EntityThumbnailTileConfig {
  subtitleKey: string;
  subtitleIcon: string;
  mobileSubtitleKey: string;
  hoverIcon: string;
  hoverLabelKey: string;
  viewMoreLabelKey: string;
  viewMoreIcon: string;
}

export const ENTITY_THUMBNAIL_TILE_CONFIGS = {
  [EntityCardEntityType.DESIGN]: {
    subtitleKey: 'pmwjs_ai_chat_select_a_design_to_open_it',
    subtitleIcon: 'icon-mouse-click',
    mobileSubtitleKey: 'pmwjs_go_to_my_stuff',
    hoverIcon: 'icon-external-link',
    hoverLabelKey: 'pmwjs_open',
    viewMoreLabelKey: 'pmwjs_view_more',
    viewMoreIcon: 'icon-designs',
  },
  [EntityCardEntityType.TEMPLATE]: {
    subtitleKey: 'pmwjs_ai_chat_select_a_template_to_open_it',
    subtitleIcon: 'icon-mouse-click',
    mobileSubtitleKey: 'pmwjs_browse_templates',
    hoverIcon: 'icon-external-link',
    hoverLabelKey: 'pmwjs_open',
    viewMoreLabelKey: 'pmwjs_view_more',
    viewMoreIcon: 'icon-templates-stack',
  },
} satisfies Partial<Record<EntityCardEntityType, EntityThumbnailTileConfig>>;

/** An entity type a thumbnail tile can show, which has its own tile config. */
export type EntityThumbnailTileEntityType = keyof typeof ENTITY_THUMBNAIL_TILE_CONFIGS;

/** One entity on the tile; its entity payload is what the entity type's click action runs with. */
export interface EntityThumbnailTileItem {
  entityRef: string;
  title: string;
  thumbnailUrl: string;
  entity: Record<string, unknown>;
}

/** Entities of one type shown as thumbnails under the reply, under the heading the agent wrote; viewMoreUrl opens the full list of them. */
export interface StreamedEntityThumbnailTileProps {
  entityType: EntityThumbnailTileEntityType;
  heading: string;
  items: EntityThumbnailTileItem[];
  viewMoreUrl: string;
}

export interface EntityThumbnailWithPayload extends EntityThumbnail {
  entity: Record<string, unknown>;
}

export type EntityThumbnailTileComponentPart = BaseComponentPart<StreamComponentType.ENTITY_THUMBNAIL_TILE, StreamedEntityThumbnailTileProps>;
